<template lang="html">
  <div class="user-details-tabs">
    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'info' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'info/undeleted'"></router-link>
      <span>info</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'transaction-history' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'transaction-history/all/all'"></router-link>
      <span>transaction history</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'cash-history' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'cash-history/all/all'"></router-link>
      <span>cash history</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'manual-history' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'manual-history/all'"></router-link>
      <span>manual history</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'point-history' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'point-history/all'"></router-link>
      <span>point history</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'bet-history' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'bet-history/all'"></router-link>
      <span>bet history</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'help-history' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'help-history/all'"></router-link>
      <span>help history</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'message-history' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'message-history/all'"></router-link>
      <span>message history</span>
    </div>

    <div
      class="user-details-tabs__items"
      :class="{ 'is-active' : $route.params.tab === 'referral-list' }"
    >
      <router-link :to="'/user/' + $route.params.id + '/' + 'referral-list/all'"></router-link>
      <span>referral list</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-details-tabs'
}
</script>
